<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <SectionTitle content="Información de Carta" has-line />

        <div
          class="
          row
        "
        >
          <div class="col-md-4 col-12 font-weight-bold">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-date-picker
                id="fundExpirationDate"
                v-model="value.letterInfo.fundExpirationDate"
                class-container="w-100 mb-3"
                custom-error-msg="El campo es requerido"
                :disabled="isReadonly"
                :error="errors[0]"
                label="Fecha de Vencimiento de Fondos:"
                placeholder="DD/MM/YYYY"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-12 font-weight-bold">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-date-picker
                id="federalFundDate"
                v-model="value.letterInfo.federalFundDate"
                class-container="w-100 mb-3"
                custom-error-msg="El campo es requerido"
                :disabled="isReadonly"
                :error="errors[0]"
                label="Fecha de Fondos Federales:"
                placeholder="DD/MM/YYYY"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-12 font-weight-bold">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-date-picker
                id="stateFundDate"
                v-model="value.letterInfo.stateFundDate"
                class-container="w-100 mb-3"
                custom-error-msg="El campo es requerido"
                :disabled="isReadonly"
                :error="errors[0]"
                label="Fecha de Fondos Estatales:"
                placeholder="DD/MM/YYYY"
              />
            </ValidationProvider>
          </div>
        </div>

        <div class="row">
          <div class="col-md-4 col-12 mb-3 font-weight-bold">
            <ValidationProvider
              v-slot="{ errors }"
              rules="required|min_value:1"
            >
              <custom-input
                id="additionalRenewalPeriod"
                v-model="value.letterInfo.additionalRenewalPeriod"
                custom-error-msg="El campo es requerido y debe ser mayor a 0"
                :disabled="isReadonly"
                :error="errors[0]"
                label="Período Adicional Renovación:"
                :min="0"
                type="number"
              />
            </ValidationProvider>
          </div>
          <div class="col-md-4 col-12 mb-3 font-weight-bold">
            <ValidationProvider v-slot="{ errors }" rules="required">
              <custom-drop-down
                id="renewalTerm"
                v-model="value.letterInfo.renewalTerm"
                :clearable="true"
                custom-error-msg="El campo es requerido"
                :disabled="isReadonly"
                :error="errors[0]"
                fieldkey="id"
                fieldname="name"
                label="Término:"
                :options="renewalTerms"
                placeholder="Seleccione"
              />
            </ValidationProvider>
          </div>
        </div>
      </div>

      <!-- Lista de firmas -->

      <div class="col-12">
        <SectionTitle content="Firma de Participantes" has-line />
        <div class="row">
          <div class="col-12">
            <participant-signature-row
              v-for="(item, index) in value.signatures"
              :key="index"
              class="mb-3"
              :is-readonly="isReadonly"
              :item="item"
              @delete="removeSignature(index)"
            />
          </div>
          <div v-if="isFormVisible" class="col-12">
            <add-participant-signature
              @add="addSignature"
              @cancel="toggleSignatureForm"
            />
          </div>
          <div
            v-if="!isFormVisible && !isReadonly"
            class="col-12 d-flex justify-content-end"
          >
            <action-button
              class="mr-2 px-3"
              i="fas fa-file-plus"
              text="Añadir"
              variant="success"
              @click="toggleSignatureForm"
            />
          </div>
        </div>
      </div>

      <div v-if="!isReadonly || isViewModeAward" class="col-12">
        <SectionTitle content="Documentos" has-line />
        <add-document
          :documents="value.documents"
          :read-only="isReadonly"
          @on-add-document="addDocumentHandler"
          @on-remove-document="removeDocumentHandler"
        />
        <error
          v-if="alertMissingDocument"
          class="mt-2"
          :message="'Al menos 1 documento es requerido'"
          variant="no-border"
        />
      </div>
    </div>
  </div>
</template>

<script>
import SectionTitle from 'SectionTitle';
import CustomDropDown from 'custom-drop-down';
import CustomInput from 'CustomInput';
import CustomDatePicker from 'custom-date-picker';
import ActionButton from 'ActionButton';
import AddDocument from './AddDocument.vue';
import AddParticipantSignature from './AddParticipantSignature.vue';
import ParticipantSignatureRow from './ParticipantSignatureRow.vue';
import { getRenewalTermTypes } from '@/modules/proposalProcess/api.js';
import Error from 'custom-error';
import letterTypes from '@/modules/proposalProcess/letterTypes.js';

export default {
  name: 'AddLetter',
  components: {
    CustomDropDown,
    CustomInput,
    SectionTitle,
    CustomDatePicker,
    ActionButton,
    AddParticipantSignature,
    ParticipantSignatureRow,
    AddDocument,
    Error,
  },
  props: {
    value: {
      type: Object,
      default: null,
    },
    isReadonly: {
      type: Boolean,
      default: false,
    },
    alertMissingDocument: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isFormVisible: false,
      renewalTerms: [],
    };
  },
  computed: {
    isViewModeAward() {
      return this.isReadonly && this.value.letterTypeId === letterTypes.AWARD;
    },
  },
  async mounted() {
    await this.getRenewalTermTypes();
  },
  methods: {
    addSignature(item) {
      this.value.signatures.push(item);
      this.toggleSignatureForm();
    },
    removeSignature(index) {
      this.value.signatures.splice(index, 1);
    },
    toggleSignatureForm() {
      this.isFormVisible = !this.isFormVisible;
    },
    async getRenewalTermTypes() {
      const { data } = await getRenewalTermTypes();
      this.renewalTerms = data;
    },
    addDocumentHandler(document) {
      this.value.documents.push(document);
    },
    removeDocumentHandler(index) {
      if (index > -1) {
        this.value.documents.splice(index, 1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep(.fa-calendar-day) {
  font-weight: 500 !important;
}
.custom-background {
  background-color: #f7f7f7;
  padding: 1%;
}
@import '@/scss/brand_variables.scss';
</style>
